import { ComponentProps } from "react";
import { useNavigate, useParams } from "react-router";
import { useInsightsAgentService } from "../../../adapters/insights-agent/state/hooks/useInsightsAgentService.tsx";
import { ResearchId } from "../../../adapters/insights-agent/state/AppState.ts";
import { HistorySidebar as HistorySidebarLegacy } from "../../../feature-components/HistorySidebar/HistorySidebar.tsx";
import { FloatingMenu } from "../../../ui-library/FloatingMenu/FloatingMenu.tsx";
import { FloatingMenuItem } from "../../../ui-library/FloatingMenu/FloatingMenuItem.tsx";

type ContextMenuComponentType = ComponentProps<
  typeof HistorySidebarLegacy
>["ContextMenuComponent"];
export const CustomContextMenu: ContextMenuComponentType = (props: {
  id: string;
}) => {
  const navigate = useNavigate();
  const { id: currentId } = useParams();
  const appService = useInsightsAgentService();
  return (
    <FloatingMenu>
      <FloatingMenuItem
        onClick={() => {
          const newName = window.prompt("Enter new name for this chat", "");
          if (!newName) return;
          appService
            .renameResearch({
              researchId: props.id as ResearchId,
              name: newName,
            })
            .then(() => {});
        }}
      >
        Rename chat
      </FloatingMenuItem>
      <FloatingMenuItem
        onClick={() => {
          const confirmed = window.confirm(
            "Are you sure you want to delete this chat?",
          );
          if (!confirmed) return;
          if (props.id === currentId) navigate("/deep-research/new");
          appService
            .deleteResearch({ researchId: props.id as ResearchId })
            .then(() => {});
        }}
      >
        Delete chat
      </FloatingMenuItem>
    </FloatingMenu>
  );
};
